import { canApplyStyle, canCopyStyle } from "@cva/shared";
import { PaintBucket, Paintbrush } from "lucide-react";
import { DropdownItem } from "../components/ui/dropdown";
import { useEditor, useEditorApi } from "./store";
import { copyStyle, pasteStyle, useStyleClipboard } from "./style-clipboard";

/** Context menu entries of „Format übertragen“. */
export function StyleTransferItems({ run }: { run: (action: () => void) => () => void }) {
  const store = useEditorApi();
  const selection = useEditor((s) => s.selection);
  const elements = useEditor((s) => s.doc.elements);
  const copied = useStyleClipboard((s) => s.style);
  const only = selection.length === 1 ? elements[selection[0]!] : undefined;
  const copyable = canCopyStyle(only);
  const pasteable = copied ? selection.some((id) => canApplyStyle(copied, elements[id])) : false;
  if (!copyable && !pasteable) return null;
  return (
    <>
      {copyable ? (
        <DropdownItem onSelect={run(() => copyStyle(store))}>
          <Paintbrush /> Format kopieren
          <span className="ml-auto pl-6 text-xs text-zinc-400">⌥⌘C</span>
        </DropdownItem>
      ) : null}
      {pasteable ? (
        <DropdownItem onSelect={run(() => pasteStyle(store))}>
          <PaintBucket /> Format einfügen
          <span className="ml-auto pl-6 text-xs text-zinc-400">⌥⌘V</span>
        </DropdownItem>
      ) : null}
    </>
  );
}
